import PropTypes from 'prop-types';

const AnyRef = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
]);

export default AnyRef;
